import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";
import NavBar from "./components/layout/NavBar";
import { RFQList } from "./components/features/rfq";
import QuoteHistory from "./pages/rfq/QuoteHistory";
import PasswordProtect from "./components/features/auth/PasswordProtect";
import { UserProvider } from "./contexts/UserContext";
import AnalyticsDashboard from "./pages/analytics/AnalyticsDashboard";
import TrackingPage from "./pages/tracking/TrackingPage";
import { BlacklistManagement } from "./components/features/blacklist";
import { InkDatabaseManagement, GenericDatabaseManagement, CuratedPricesManagement, GeneralItemsManagement } from "./pages/databases";
import ServiceStatusBanner from "./components/shared/ServiceStatusBanner";
import ErrorBoundary from "./components/shared/ErrorBoundary";
import ChatPanel from "./components/features/chat/ChatPanel";

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <UserProvider>
          <PasswordProtect>
            <Router>
              <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <NavBar />

                <ServiceStatusBanner />

                <Box component="main" sx={{ flex: 1, minWidth: 0 }}>
                  <ErrorBoundary>
                    <Routes>
                      <Route path="/" element={<RFQList />} />
                      <Route path="/rfqs" element={<RFQList />} />
                      <Route path="/quote-history" element={<QuoteHistory />} />
                      <Route path="/analytics" element={<AnalyticsDashboard />} />
                      <Route path="/tracking" element={<TrackingPage />} />
                      <Route path="/databases/ink" element={<InkDatabaseManagement />} />
                      <Route path="/databases/generic" element={<GenericDatabaseManagement />} />
                      <Route path="/databases/curated" element={<CuratedPricesManagement />} />
                      <Route path="/databases/general" element={<GeneralItemsManagement />} />
                      <Route path="/blacklist" element={<BlacklistManagement />} />
                    </Routes>
                  </ErrorBoundary>
                </Box>
                <ChatPanel />
              </Box>
            </Router>
          </PasswordProtect>
        </UserProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
